import React, { useContext, useState } from "react";
import { NotificationInfo, SubscriptionInfo, UserInfo } from "../../../context";
import MerchantLayout from "../../layout/MerchantLayout";
import { Button, Input, Modal, QRCode, Typography } from "antd";
import axios from "axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import LOGO from "./../../../assets/tinyimg/logo.webp";

const MerchantQRCode = () => {
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const navigate = useNavigate();
  const [copiedOrder, setCopiedOrder] = useState(false);
  const [copiedQueue, setCopiedQueue] = useState(false);
  const [copiedAttendance, setCopiedAttendance] = useState(false);

  const downloadQRCode = () => {
    const canvas = document.getElementById("myqrcode")?.querySelector("canvas");
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement("a");
      a.download = "QRCode.png";
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  const handleChangeUID = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    axios
      .post("user/merchant/update-merchant-uid", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated UID successfully.");
          setTimeout(() => {
            // handleRerunUser();
            window.location.reload();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleCopyClick = async (id) => {
    try {
      var copyText = document.getElementById(id).textContent;
      navigator.clipboard.writeText(copyText);
      if (id === "ordering-url") {
        setCopiedOrder(true);
        setTimeout(() => {
          setCopiedOrder(false);
        }, 5000);
      }

      if (id === "queuing-url") {
        setCopiedQueue(true);
        setTimeout(() => {
          setCopiedQueue(false);
        }, 5000);
      }

      if (id === "attendance-url") {
        setCopiedAttendance(true);
        setTimeout(() => {
          setCopiedAttendance(false);
        }, 5000);
      }
    } catch (err) {
      console.error("Error copying to clipboard:", err);
    }
  };

  return (
    <MerchantLayout>
      <div
        id="myqrcode"
        style={{
          borderBottom: "1px solid #e5e5e5",
          // marginBottom: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
        }}
      >
        <QRCode
          value={`${import.meta.env.VITE_API_SITE_URL}${userData.data.id}/${
            userData.data.merchant_uid
          }`}
          style={{
            marginBottom: 16,
          }}
          icon={
            userData.data.usersmerinfo.business_logo !== null
              ? `${import.meta.env.VITE_API_IMAGE}logo/${
                  userData.data.usersmerinfo.business_logo
                }`
              : LOGO
          }
          errorLevel="Q"
        />
        <Button type="primary" onClick={downloadQRCode}>
          Download
        </Button>
      </div>
      <div
        id="myqrcode"
        style={{
          borderBottom: "1px solid #e5e5e5",
          // marginBottom: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
        }}
      >
        <Typography
          style={{ marginBottom: 10, fontSize: 20, fontWeight: "bold" }}
        >
          Customer Ordering URL
        </Typography>
        <Typography
          style={{
            marginBottom: 5,
            fontSize: 14,
            color: "blue",
            border: "1px solid #e5e5e5",
            padding: 5,
            borderRadius: 5,
          }}
          id="ordering-url"
        >
          {`${window.location.origin}/${userData.data.id}/${userData.data.merchant_uid}`}
        </Typography>

        <Button
          type="primary"
          onClick={() => handleCopyClick("ordering-url")}
          style={{ backgroundColor: copiedOrder ? "#2ecc71" : "#1677ff" }}
        >
          {copiedOrder ? "Copied!" : "Copy to Clipboard"}
        </Button>
      </div>
      <div
        id="myqrcode"
        style={{
          borderBottom: "1px solid #e5e5e5",
          // marginBottom: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
        }}
      >
        <Typography
          style={{ marginBottom: 10, fontSize: 20, fontWeight: "bold" }}
        >
          Attendance URL
        </Typography>
        <Typography
          style={{
            marginBottom: 5,
            fontSize: 14,
            color: "blue",
            border: "1px solid #e5e5e5",
            padding: 5,
            borderRadius: 5,
          }}
          id="attendance-url"
        >
          {`${window.location.origin}/attendance/${userData.data.id}/${userData.data.merchant_uid}`}
        </Typography>

        <Button
          type="primary"
          onClick={() => handleCopyClick("attendance-url")}
          style={{ backgroundColor: copiedAttendance ? "#2ecc71" : "#1677ff" }}
        >
          {copiedAttendance ? "Copied!" : "Copy to Clipboard"}
        </Button>
      </div>
      <div
        id="myqrcode"
        style={{
          borderBottom: "1px solid #e5e5e5",
          // marginBottom: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
        }}
      >
        <Typography
          style={{ marginBottom: 10, fontSize: 20, fontWeight: "bold" }}
        >
          Queuing URL
        </Typography>
        <Typography
          style={{
            marginBottom: 5,
            fontSize: 14,
            color: "blue",
            border: "1px solid #e5e5e5",
            padding: 5,
            borderRadius: 5,
          }}
          id="queuing-url"
        >
          {`${window.location.origin}/queuing/${userData.data.id}/${userData.data.merchant_uid}`}
          {/* {`${window.location.origin}/queuing`} */}
        </Typography>

        <Button
          type="primary"
          onClick={() => handleCopyClick("queuing-url")}
          style={{ backgroundColor: copiedQueue ? "#2ecc71" : "#1677ff" }}
        >
          {copiedQueue ? "Copied!" : "Copy to Clipboard"}
        </Button>
      </div>
      <div
        id="myqrcode"
        style={{
          borderBottom: "1px solid #e5e5e5",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 20,
        }}
      >
        <Input
          id="merchantuid"
          defaultValue={userData.data.merchant_uid}
          style={{ width: 300, marginBottom: 16 }}
          disabled
        />
        <Button
          type="primary"
          onClick={handleChangeUID}
          style={{ width: 100 }}
          disabled
        >
          Change UID
        </Button>
      </div>

      {/* {console.log("URL", window.location.origin)} */}

      {console.log(
        "QRCODE",
        `${import.meta.env.VITE_API_SITE_URL}${userData.data.id}/${
          userData.data.merchant_uid
        }`
      )}

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantQRCode;
